import React from "react";

function Ball(props) {
  const { info, index, onShot, stop } = props;

  const onTouchStart = (e) => {
    if (!stop) onShot(e.touches[0].clientX, e.touches[0].clientY, info.score);
  };

  const onClick = (e) => {
    if (!stop) onShot(e.clientX, e.clientY, info.score);
  };

  return (
    <div
      className="BallItem"
      style={{
        position: "absolute",
        left: info.x,
        top: info.y,
        width: info.size,
        height: info.size,
      }}
    >
      <div
        style={{
          left: -16,
          top: -16,
          width: info.size + 24,
          height: info.size + 24,
        }}
        className={
          index % 2 === 0 && !stop
            ? "BallItemOutline rotate-center"
            : !stop
            ? "BallItemOutline rotate-center-reverse"
            : "BallItemOutline"
        }
        onTouchStart={onTouchStart}
        onClick={onClick}
      />
    </div>
  );
}

export default Ball;
